import React from 'react';

const InstallAppContinueLink = ({ label, onClick }) => (
    <button
        type="button"
        className="install-app-continue-link"
        onClick={onClick}
    >
        {label}
    </button>
);

export default InstallAppContinueLink;
